export const getLanguageFromLocale = (locale: string): string => {
  const language = (locale?.split('-') || ['en'])[0]
  return language ?? 'en'
}
